import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { EventSearchResults } from '2-feature/Search/EventSearchResults';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

interface Props extends Content.Page {
	properties: Content.EventCatalogPageProperties;
}

export const EventCatalogPage = ({ properties }: Props) => {
	const { pageHeader, events, filterTags, totalEvents } = properties ?? {};

	return (
		<MainRegion
			header={pageHeader.map((headerModule, index) => (
				<DynamicModule key={index} module={headerModule} />
			))}
		>
			<CludoComment>
				<EventSearchResults serverSideEvents={events} tags={filterTags} totalEvents={totalEvents} />
			</CludoComment>
			<GoToTopNavigation />
		</MainRegion>
	);
};
